<template>
    <div>
        <Calendar :form-errors="errors" />
    </div>
</template>

<script>
import Calendar from "../../components/UI/sections/Calendar.vue";
import CalendarV2 from "../../components/UI/sections/CalendarV2.vue";
export default {
    name: "TrainingCalendar",
    components: {
        Calendar
    },
    data() {
        return {
            
        }
    },
}
</script>

<style lang="scss" scoped></style>